import { UPDATE_STYLE_PARAMS_FONTS } from '../actions';
import { Reducer } from 'redux';

const INITIAL_STATE = {};

export const fonts: Reducer<{ [key: string]: string }> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case UPDATE_STYLE_PARAMS_FONTS: {
      return { ...state, ...action.fonts };
    }
    default:
      return state;
  }
};
